import React from 'react'
import useSearch from '../../hooks/SearchContext'

import HeaderNavigation from '../HeaderNavigation'
import BrandHeader from '../Title'
import { ReactComponent as SearchSvg } from '../../assets/search.svg'
import { ImageRelativeBrand } from '../../utils/LogoForBrands'
import { storedEnv } from '../../utils/localStorage'
import SendGTAGEvent from '../../utils/sendGTAGEvent'

import * as S from './styles';

interface ILayoutHeaderProps {
    className?: string;
    deleteNav?: boolean;
    onOpenAside: () => void;
    navigationItems: {
        label: string;
        to: string;
    }[]
}

const LayoutHeader: React.FC<ILayoutHeaderProps> = ({ deleteNav, onOpenAside, navigationItems, className }) => {
    const { isOpenSearch, showButtonSearch, widthWindow, onOpenCloseSearchHandler } = useSearch()

    return (
        <S.Container className={isOpenSearch ? className : ""}>
            <S.BrandHeaderContainer>
                <S.DivHeader>
                    <BrandHeader />

                </S.DivHeader>

                <HeaderNavigation
                    className="nav__desktop--container"
                    navigationItems={navigationItems}
                    deleteNav={deleteNav} />

                <S.IconsHeaderNavigation>

                    {showButtonSearch && widthWindow < 768 &&
                        <S.SearchButton isOpen={isOpenSearch} onClick={onOpenCloseSearchHandler} className="SearchButton">
                            <SearchSvg />
                        </S.SearchButton>
                    }
                    {showButtonSearch && widthWindow >= 768 &&
                        <S.SearchButton isOpen={isOpenSearch} onClick={onOpenCloseSearchHandler} className="SearchButton">
                            <SearchSvg />
                            <span>Buscar</span>
                        </S.SearchButton>
                    }
                    <S.UserIconContainer>
                        <img className="svg__user--button"
                            onClick={() => {
                                onOpenAside()
                                SendGTAGEvent(
                                    'botao_user',
                                    'Usuario',
                                    'Clicou no botão de usuário',
                                )
                            }}
                            src={ImageRelativeBrand(storedEnv || '').Image} alt='logo' />
                    </S.UserIconContainer>
                </S.IconsHeaderNavigation>

            </S.BrandHeaderContainer>
        </S.Container>
    )
}

export default LayoutHeader